import { render, staticRenderFns } from "./ScrollStory.vue?vue&type=template&id=54597f9e&"
import script from "./ScrollStory.vue?vue&type=script&lang=js&"
export * from "./ScrollStory.vue?vue&type=script&lang=js&"
import style0 from "./ScrollStory.vue?vue&type=style&index=0&id=54597f9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports